module.exports = __webpack_public_path__ + "img/home_3.d56d9b65.jpg";